export default "__VITE_ASSET__CMeQfoOt__"